// extracted by mini-css-extract-plugin
export var burgerContainer = "HeaderDesktop-module--burgerContainer--4e7cb";
export var header = "HeaderDesktop-module--header--5399b";
export var headerMain = "HeaderDesktop-module--headerMain--a4b75";
export var horizontalSpacer = "HeaderDesktop-module--horizontalSpacer--b9812";
export var languageAndSearch = "HeaderDesktop-module--languageAndSearch--2b49a";
export var languageChevronDown = "HeaderDesktop-module--languageChevronDown--2a0c5";
export var languageMenu = "HeaderDesktop-module--languageMenu--f1652";
export var languageMenuContainer = "HeaderDesktop-module--languageMenuContainer--b71b0";
export var languageMenuOverlay = "HeaderDesktop-module--languageMenuOverlay--65ab5";
export var languageMenuTitle = "HeaderDesktop-module--languageMenuTitle--1c75e";
export var languageSwitch = "HeaderDesktop-module--languageSwitch--582bd";
export var languageSwitchFlag = "HeaderDesktop-module--languageSwitchFlag--54d68";
export var navMenuChevronDown = "HeaderDesktop-module--navMenuChevronDown--556dc";
export var navMenuPrimary = "HeaderDesktop-module--navMenuPrimary--6169e";
export var navMenuPrimaryItem = "HeaderDesktop-module--navMenuPrimaryItem--b133c";
export var navOverlay = "HeaderDesktop-module--navOverlay--4e7e3";
export var navSecondaryDesktop = "HeaderDesktop-module--navSecondaryDesktop--8e9bb";
export var navSecondaryItem = "HeaderDesktop-module--navSecondaryItem--e86c9";
export var navSecondaryItemImage = "HeaderDesktop-module--navSecondaryItemImage--ed074";
export var navSecondaryItemLabel = "HeaderDesktop-module--navSecondaryItemLabel--4dd1b";
export var navTertiary = "HeaderDesktop-module--navTertiary--e7e08";
export var navTertiaryItem = "HeaderDesktop-module--navTertiaryItem--3e538";
export var navTertiaryItemImage = "HeaderDesktop-module--navTertiaryItemImage--cb2b9";
export var navTertiaryItemLabel = "HeaderDesktop-module--navTertiaryItemLabel--f8672";
export var ridestoreLogoDesktop = "HeaderDesktop-module--ridestoreLogoDesktop--58e0c";
export var searchIcon = "HeaderDesktop-module--searchIcon--d87a7";
export var searchItem = "HeaderDesktop-module--searchItem--c9b36";
export var skipContentButton = "HeaderDesktop-module--skipContentButton--c7653";
export var sustainability = "HeaderDesktop-module--sustainability--07dbc";